import { Box, Typography, useTheme ,Stack,Button,IconButton} from "@mui/material";
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import NiceDate from "../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getUserRoles} from "../../slices/auth";
import { setMessage } from "../../slices/message"
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckIcon from '@mui/icons-material/Check';
import NiceUser from "../../components/global/NiceUser";

const UserRoles = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const roles = useSelector((state) => state.auth.user_roles.data);

  //debugger;

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);


  useEffect(() => {

    const search = {
      page,
      pageSize,
    }

    dispatch(getUserRoles({search}));

}, [page,pageSize]);

const processRowUpdate = React.useCallback(
  async (newRow) => {
    // Make the HTTP request to save in the backend
    //debugger
    const id = newRow.id;
    const isBlocked = newRow.is_blocked;

    //dispatch(updateSession({id,isBlocked}));

    return newRow;
  },
  [roles],
);

const handleProcessRowUpdateError = React.useCallback((error) => {
  dispatch(setMessage("Error editing Row"));
}, []);


  const columns = [
    { 
      field: "id", 
      headerName: "ID" ,
      hide: true,
    },
    {
      field: "username",
      headerName: "User",
      flex: 1,
      renderCell: ({row: {username}}) => {

        return (
          <NiceUser>{username}</NiceUser>
        )
      }
    },
    {
      field: "roleId",
      headerName: "Role",
      flex: 1,
      //cellClassName: "name-column--cell",
    },
    {
      field: "objectType",
      headerName: "Applies to",
      flex: 1,
      //cellClassName: "name-column--cell",
    },
    {
      field: "objectId",
      headerName: "Specifically",
      flex: 1,
      //cellClassName: "name-column--cell",
    },
    {
      field: "active",
      headerName: "Role Active",
      type:"boolean",
      editable: true ,
      renderCell: ({row: {active}}) => {

        return (
          <Box>
          {active &&
            <CheckIcon />
          }
          </Box>
        )
      }

    },

    {
      headerName: "Actions",
      field:"",
      flex: 1,
      type:"actions",
      disableClickEventBubbling: true,
      
      renderCell: (params) => {
          const handleUbBlock = (e) => {
            const currentRow = params.row;
            const session_id = currentRow.id;
            
            const id = currentRow.id
            const isBlocked = false;

            //dispatch(updateSession({id,isBlocked}));

          };

          const handleBlock = (e) => {
            const currentRow = params.row;
            const session_id = currentRow.id;
            
            const id = currentRow.id
            const isBlocked = true;

            //dispatch(updateSession({id,isBlocked}));

          };

          const handleDelete = (e) => {
            const currentRow = params.row;
            const session_id = currentRow.id;
            
            const id = currentRow.id
            const isBlocked = true;

            //dispatch(updateSession({id,isBlocked}));

          };
          

          return (
            
            <Stack key={"STACK-" + params.row.id}  direction="row" spacing={2}>
              {params.row.isBlocked ?
              <IconButton key={"LOCK-" + params.row.id} aria-label="unblock" onClick={handleUbBlock}>
                <LockOpenIcon />
              </IconButton>
              :
              <IconButton key={"UNLOCK-" + params.row.id}  aria-label="block" onClick={handleBlock}>
                <LockIcon />
              </IconButton>
      }
              <IconButton key={"DELETE-" + params.row.id} aria-label="delete" onClick={handleDelete} disabled>
                <DeleteIcon />
              </IconButton>

            </Stack>
          );
      },
    },

  ];

  return (

    <Box m="20px">

      <Header title="User Roles" subtitle="List of user roles" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

          <DataGrid  experimentalFeatures={{newEditingApi: true }}
            
            processRowUpdate={processRowUpdate}
            onProcessRowUpdateError={handleProcessRowUpdateError}
            rows={roles.list} 
            columns={columns} 
            pageSize={pageSize}
            page={roles.page}
            rowsPerPageOptions={[10, 25,50,100]}
            paginationMode="server"
            rowCount={roles.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            
          />    

      </Box>
    </Box>
  );
};

export default UserRoles;
